//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';
import { Icon, UnisonIconType } from 'unison';


interface IThresholdDescriptionProps {
  iconName: UnisonIconType;
  message: string;
  information: string;
  iconClass: string;
}

export const ThresholdStatus = (props: IThresholdDescriptionProps) => {
  const {
    iconName,
    message,
    information,
    iconClass,
  } = props;

  return (
    <>
      <HeaderContainer>
        <div className='cu-text-subtitle'>
          <ThresholdIcon className={ iconClass } name={ iconName } />
          { message }
        </div>
      </HeaderContainer>
      <div className='cu-text-body cu-py-2'>
        { information }
      </div>
    </>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const ThresholdIcon = styled(Icon)`
  margin-right: ${({theme}) => theme.spacings['2']};
  margin-bottom: 2px;
  && svg {
    width: ${({theme}) => theme.spacings['4']};
    height: ${({theme}) => theme.spacings['4']};
  }
`;

export default ThresholdStatus;
